/**
 * TanStack Query hooks for `criteo-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	criteoIntegrationQueryKeys,
	type CreateCriteoIntegrationBody,
	type ListCriteoIntegrationResponse,
	type CriteoIntegrationRow,
} from "./api";

export function useCriteoIntegrationList(): UseQueryResult<ListCriteoIntegrationResponse, Error> {
	return useQuery({
		queryKey: criteoIntegrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useCriteoIntegrationCreate(): UseMutationResult<CriteoIntegrationRow, Error, CreateCriteoIntegrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: criteoIntegrationQueryKeys.all });
		},
	});
}

export function useCriteoIntegrationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: criteoIntegrationQueryKeys.all });
		},
	});
}
